import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { ToastProvider } from './context/ToastContext';
import { LocalVehicleProvider } from './context/LocalVehicleContext';
import { AuthProvider } from './context/AuthContext';

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><ToastProvider><LocalVehicleProvider><AuthProvider><App/></AuthProvider></LocalVehicleProvider></ToastProvider></BrowserRouter></StrictMode>);
